<template>
  <div class="modal fade" id="add_reminder" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-warning">
            <h3 class="block-title"><i class="fa fa-broadcast-tower"></i> Reminders</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" @click.prevent="clearData()" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="row">
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required">
                <label class="control-label">Task Name</label>
                <input type="text" v-model="name" name="name" v-validate="'required'" data-vv-as="Task Name" class="form-control form-control-alt" placeholder="Task Name">
                <p v-if="errors.has('name')" class="errorMsg">{{ errors.first('name') }}</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <label>Description</label>
                <textarea v-model="description" class="form-control form-control-alt" placeholder="Description">{{ description }}</textarea>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required">
                <label class="control-label">Start date</label>
                <input v-model="startDate" name="start_date" id="start-date" type="text" v-validate="'required'" data-vv-as="Start date" class="form-control form-control-alt" placeholder="Start Date" />
                <p v-if="errors.has('start_date')" class="errorMsg">{{ errors.first('start_date') }}</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <label>Due date</label>
                <input v-model="dueDate" id="due-date" type="text" class="form-control form-control-alt" placeholder="Due Date" />
              </div>
              <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 toggle-button">
                <label>Repeats?</label>
                <div class="custom-control custom-switch custom-control-inline">
                  <input type="checkbox" v-model="repeatStatus" @change="patternReset()" id="repeat" class="custom-control-input">
                  <label class="custom-control-label" for="repeat"></label>
                </div>
              </div>
              <div class="form-group col-12 col-sm-hidden col-md-12 col-lg-6 col-xl-6"></div>
              <transition name="slide-fade-option">
                <div v-show="repeatStatus" class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" id="repeat.recurrencePattern-section">
                  <label>Repeat Task</label>
                  <select v-model="repeat.recurrencePattern" @change="resetOption" class="form-control form-control-alt" id="repeat-pattern">
                    <option value="1">Daily</option>
                    <option value="2">Every other day</option>
                    <option value="3">Custom</option>
                    <option value="4">Weekly</option>
                    <option value="5">Monthly</option>
                  </select>
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="repeatStatus && repeat.recurrencePattern == 2" class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" id="week-days">
                  <label>Select a day(s)</label>
                  <div v-for="(day, index) in repeat.days" :key="day.name" class="custom-control custom-checkbox custom-control-inline">
                    <input v-validate="'required'" v-model="repeat.selectedDays" :value="day.value" type="checkbox" class="custom-control-input" :id="day.name" name="days" data-vv-as="Days">
                    <label class="custom-control-label" :for="day.name">{{ day.name }}</label>
                  </div>
                  <p v-if="errors.has('days')" class="errorMsg">{{ errors.first('days') }}</p>
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="repeatStatus && repeat.recurrencePattern == 3" class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div id="custom">
                    <label>Repeats every</label>
                    <input type="number" onkeypress="return event.charCode >= 48" min="1" v-model="repeat.custom.dayCount" class="form-control form-control-alt">
                    <select v-model="repeat.custom.period" class="form-control form-control-alt">
                      <option value="1">day(s)</option>
                      <option value="2">Week(s)</option>
                      <option value="3">Month(s)</option>
                    </select>
                  </div>
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="repeatStatus && repeat.recurrencePattern == 4" class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" id="days">
                  <label>Select a day</label>
                  <select v-model="repeat.weekly.option" class="form-control form-control-alt">
                    <option v-for="(day, index) in repeat.days" :key="index" :value="day.value"> {{ day.name }}</option>
                  </select>
                </div>
              </transition>
              <transition name="slide-fade">
                <div v-show="repeatStatus && repeat.recurrencePattern == 5" class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" id="monthly">
                  <label>On</label>
                  <select v-model="repeat.monthly.option" class="form-control form-control-alt">
                    <option value="first">First</option>
                    <option value="second">Second</option>
                    <option value="third">Third</option>
                    <option value="fourth">Fourth</option>
                    <option value="last">Last</option>
                  </select>
                  <select v-model="repeat.monthly.day" class="form-control form-control-alt">
                    <option v-for="(day, index) in repeat.days" :key="index" :value="day.value"> {{ day.name }}</option>
                  </select>
                </div>
              </transition>
            </div>
            <transition name="slide-fade-option">
              <div v-show="repeatStatus" class="radio-content block-content">
                <label>Ends</label>
                <div class="radio-content block-content row">
                  <div class="form-check col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 form-group">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input class="custom-control-input" v-model="repeat.end.option" value="1" type="radio" id="never-end" name="end">
                      <label class="custom-control-label" for="never-end">Never</label>
                    </div>
                  </div>
                  <div class="radio-button form-check form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input class="custom-control-input" v-model="repeat.end.option" value="2" type="radio" id="end-by-date" name="end">
                      <label class="custom-control-label" for="end-by-date">On</label>
                      <input v-model="repeat.end.endDate" id="end-date" type="text" class="form-control form-control-alt" placeholder="Date"/>
                    </div>
                  </div>
                  <div class="radio-button form-check col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input class="custom-control-input" v-model="repeat.end.option" value="3" type="radio" id="end-by-occurence" name="end">
                      <label class="custom-control-label" for="end-by-occurence">After</label>
                      <input v-model="repeat.end.occurrenceCount" type="number" onkeypress="return event.charCode >= 48" min="1" class="form-control form-control-alt" />
                      occurrence
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="block-content block-content-full text-right border-top button-loader">
              <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
              <button type="button" class="btn btn-sm btn-primary" @click="store" :bind:disabled="showModalLoader">
                <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                <span class="modal-loader" v-show="showModalLoader">
                  <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { mapActions, mapGetters } from 'vuex';
import VeeValidate from 'vee-validate';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'AddReminder',
  data() {
    return {
      name: '',
      repeatStatus: false,
      startDate: new Date().toJSON().slice(0,10),
      dueDate: new Date().toJSON().slice(0,10),
      description: '',
      repeat: {
        recurrencePattern: 1,
        days: [
          {name: 'Monday', value: 1},
          {name: 'Tuesday', value: 2},
          {name: 'Wednesday', value: 3},
          {name: 'Thursday', value: 4},
          {name: 'Friday', value: 5},
          {name: 'Saturday', value: 6},
          {name: 'Sunday', value: 7}
        ],
        selectedDays: [],
        custom: { dayCount: 1, period: 1 },
        weekly: { option: 1},
        monthly: { option: 'first', day: 1},
        end: {
          option: 2,
          endDate: new Date().toJSON().slice(0,10),
          occurrenceCount: 1
        }
      },
      showModalLoader: false,
      errorMessage: ''
    };
  },
  components: {
    HashLoader
  },
  mounted: function() {
    let vm = this, date = new Date(), dateOptions;
    vm.repeat.selectedDays.push(1);
    date.setDate(date.getDate()-1);
    dateOptions = {
      startDate: new Date().toJSON().slice(0,10),
      format: 'yyyy-mm-dd',
      autoclose:true
    };
    $('#due-date').datepicker(dateOptions);
    $('#end-date').datepicker(dateOptions);
    $('#start-date')
      .datepicker(dateOptions)
      .on('changeDate', function(selected) {
        let startDate = selected.date.valueOf(),
            startDateVal = $(this).val(),
            minDate = new Date(startDate),
            dueDate = $('#due-date').datepicker('getDate').valueOf(),
            endDate = $('#end-date').datepicker('getDate').valueOf();
        vm.startDate = startDateVal;
        if (startDate > dueDate) {
          vm.dueDate = startDateVal;
          $('#due-date').datepicker('setStartDate', minDate);
          $('#due-date').datepicker('setDate', minDate);
        }
        if (startDate > endDate) {
          vm.repeat.end.endDate = startDateVal;
          $('#end-date').datepicker('setStartDate', minDate);
          $('#end-date').datepicker('setDate', minDate);
        }
      });
    $('#due-date').change(function() { vm.dueDate = $(this).val(); });
    $('#end-date').change(function() { vm.repeat.end.endDate = $(this).val(); });
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllTodoList', 'getRecentNotificationList', 'getRecentNotificationCount']),
    ...mapGetters('library', ['getTodoList']),
    store() {
      let vm = this;
      vm.errorMsg = '';
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          let repeat = vm.getRepeatDetails();
          helper.sendPostRequest('/todo/add', {
            todo: {
              name: vm.name,
              startDate: vm.startDate,
              description: vm.description,
              dueDate: vm.dueDate,
              repeatStatus: vm.repeatStatus,
              recurrencePattern: repeat.recurrencePattern,
              repeatOtherDays: repeat.repeatOtherDays,
              repeatCustomDay: repeat.repeatCustomDay,
              repeatCustomOption: repeat.repeatCustomOption,
              repeatWeeklyDay: repeat.repeatWeeklyDay,
              repeatMonthlyWeek: repeat.repeatMonthlyWeek,
              repeatMonthlyDay: repeat.repeatMonthlyDay,
              repeatPatternDouranceType: repeat.repeatPatternDouranceType,
              repeatPatternEnd: repeat.repeatPatternEnd,
              repeatPatternEndDate: repeat.repeatPatternEndDate
            }
          }).then((data) => {
            if (data.status === 'success') {
              jQuery('#add_reminder').modal('hide');
              vm.success(data.message);
              vm.clearData();
              vm.triggerMessageModal('#alert_modal');
              vm.getAllTodoList();
              vm.getRecentNotificationList();
              vm.getRecentNotificationCount();
            } else {
              vm.errorMsg = data.message;
            }
          }).catch(function() {
            vm.error('Unable to process your request, Please try again later.');
            vm.triggerMessageModal('#alert_modal');
          });
        }
      });
      vm.showModalLoader = false;
    },
    getRepeatDetails() {
      let repeat = {
        recurrencePattern: 0,
        repeatOtherDays: [],
        repeatCustomDay: 0,
        repeatCustomOption: 0,
        repeatWeeklyDay: 0,
        repeatMonthlyWeek: '',
        repeatMonthlyDay: 0,
        repeatPatternDouranceType: 0,
        repeatPatternEnd: 0,
        repeatPatternEndDate: ''
      };

      if (!this.repeatStatus) {
        return repeat;
      }

      switch (parseInt(this.repeat.recurrencePattern)) {
        case 2:
          repeat.repeatOtherDays = this.repeat.selectedDays;
          break;
        case 3:
          repeat.repeatCustomDay = this.repeat.custom.dayCount;
          repeat.repeatCustomOption = this.repeat.custom.period;
          break;
        case 4:
          repeat.repeatWeeklyDay = this.repeat.weekly.option;
          break;
        case 5:
          repeat.repeatMonthlyWeek = this.repeat.monthly.option;
          repeat.repeatMonthlyDay = this.repeat.monthly.day;
          break;
      }

      if (parseInt(this.repeat.end.option) === 2) {
        repeat.repeatPatternEndDate = this.repeat.end.endDate;
      } else if (parseInt(this.repeat.end.option) === 3) {
        repeat.repeatPatternEnd = this.repeat.end.occurrenceCount;
      } else {
        //nothing
      }
      repeat.repeatPatternDouranceType = this.repeat.end.option;
      repeat.recurrencePattern = this.repeat.recurrencePattern;

      return repeat;
    },
    patternReset() {
      if (this.repeatStatus === false) {
        this.repeat.recurrencePattern = 1;
        this.repeat.end.endDate = new Date().toJSON().slice(0,10);
        this.repeat.end.option = 2;
        this.repeat.end.occurrenceCount = 1;
      }
    },
    clearData() {
      this.name = '';
      this.errorMsg = '';
      this.repeatStatus = false;
      this.startDate = new Date().toJSON().slice(0,10);
      this.dueDate = new Date().toJSON().slice(0,10);
      this.repeat.end.endDate = new Date().toJSON().slice(0,10);
      this.description = '';
      this.errorMessage = '';
      this.showModalLoader = false;
      this.repeatStatus = false;
      this.repeat.recurrencePattern = 1;
      this.resetOption();
      $('.datepicker').datepicker('update', new Date().toJSON().slice(0,10));
      this.$validator.reset();
    },
    resetOption() {
      this.repeat.selectedDays = [];
      this.repeat.selectedDays.push(1);
      this.repeat.custom.dayCount = 1;
      this.repeat.custom.period = 1;
      this.repeat.weekly.option = 1;
      this.repeat.monthly.option = 'first';
      this.repeat.monthly.day = 1;
      this.repeat.end.endDate = new Date().toJSON().slice(0,10);
      this.repeat.end.option = 2;
      this.repeat.end.occurrenceCount = 1;
    }
  }
};
</script>

<style scoped>
#monthly select {
  width: 100%;
  display: inline-block;
  margin: 5px 0;
}
#week-days .custom-control-inline {
  width: 100%;
}
.slide-fade-enter-active,
.slide-fade-option-enter-active {
  transition: all .6s ease;
}
.slide-fade-leave-active {
  transition: all .0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-option-leave-active {
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to,
.slide-fade-option-enter, .slide-fade-option-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
#custom label {
  width:100%;
}
#custom input {
  width: 81px;
  display: inline-block;
  margin-right: 10px;
}
#custom select {
  width: calc(100% - 96px);
  display: inline-block;
}
.form-check input[type="number"] {
  width: 81px;
  display: inline-block;
  position: relative;
  top: -5px;
  margin-left: 5px;
  margin-right: 5px;
}
.form-check input[type="text"] {
  width: 130px;
  display: inline-block;
  position: relative;
  top: -5px;
  margin-left: 5px;
  margin-right: 5px;
}
.radio-button .form-check-input {
  top: 8px;
}
.form-check {
  padding-left: 0;
}
.radio-content.block-content {
  padding: 0;
}
label {
  width: 100%;
}
@media only screen and (min-width: 500px) {
  #week-days .custom-control-inline {
    width: 30%;
  }
}
@media only screen and (min-width: 767px) {
  #monthly select {
    width: 49%;
    display: inline-block;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// source/components/modals/AddReminder.vue